import { v4 } from 'uuid';

export type Uuid = {
  v4: typeof v4;
};

/**
 */
export const UuidProvider = {
  provide: 'uuid',
  useValue: { v4 },
};
